import { customBaseUrl, httpPost, httpGet } from "../../store/http";

const { authUrl } = customBaseUrl;

export const searchUsers = async (query) => {
  if (!query) return { success: true, data: { users: [] } };
  
  const isEmail = query.includes("@");
  
  if (isEmail) {
    const url = `${authUrl}/admin/users/email/${query}`;
    const res = await httpGet(url);
    // Normalize response to match the search list format
    if (res?.success && res.data) {
      return { ...res, data: { users: [res.data] } };
    }
    return { success: true, data: { users: [] } };
  } else {
    // Name search
    const url = `${authUrl}/admin/users/search`;
    return await httpPost(url, { firstName: query });
  }
};

export const getUserById = async (userId) => {
  return await httpGet(`${authUrl}/admin/users/${userId}`);
};
